/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
// @ts-nocheck
import PopupInputCode from "components/popup-input-code";
import PopupMessage from "components/popup-message";
import PopupOtp from "components/popup-otp";
import {
  CAMPAIGNID,
  END_DATE,
  START_DATE,
  TENANTID,
  HOTLINE,
} from "constants/common";
import moment from "moment";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import actions from "redux/home/actions";
import HomePageView from "./view";
import { signInWithCustomToken, getAuth } from "firebase/auth";
import LoadingSpinner from "components/LoadingSpinner";
import PopupGiftTopup from "components/popup-gift-topup";
import PopupNoGift from "components/popup-no-gift";
import { checkPhoneNetwork } from "utils";
import Cookies from "universal-cookie";
import PopupVideo from "components/popup-card";
import PopupCard from "components/popup-card";
import PopupImage from "components/popup-image";

const HomePage = () => {
  const myRef = useRef(null);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    getValues,
    reset,
  } = useForm();
  const cookies = new Cookies();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [modalOtp, setModalOtp] = useState(false);
  const [modalInput, setModalInput] = useState(false);
  const [modalCard, setModalCard] = useState(false);
  const [modalImage, setModalImage] = useState(false);

  const [content, setContent] = useState("");
  const [otp, setOtp] = useState("");
  const [isErrorOTP, setIsErrorOTP] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowModalNoGift, setIsShowModalNoGift] = useState(false);
  const [code, setCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [address, setAddress] = useState("");
  const [OtpRequestTime, setOtpRequestTime] = useState("");
  const [OtpResponseTime, setOtpResponseTime] = useState("");
  const [dataSubmit, setDataSubmit] = useState({});
  const [nameBtn, setNameBtn] = useState("");
  const [nameBtn1, setNameBtn1] = useState("");
  const [nameBtn2, setNameBtn2] = useState("");
  const [timerId, setTimerId] = useState(null);
  const [dataModalTopup, setDataModalTopup] = useState({});
  const [provinces, setProvinces] = useState([]);
  const [isErrorPhoneNumber, setIsErrorPhoneNumber] = useState(false);
  const [networkPhone, setNetworkPhone] = useState("");
  const [store, setStore] = useState({});
  const [contentCard, setContentCard] = useState(null);
  useEffect(() => {
    reset();
  }, []);

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      console.log("value, { name, type }", value, name, type);
      let isErr = false;
      if (name === "phone") {
        if (value.phone.length >= 3) {
          let networkPhoneTmp = checkPhoneNetwork(
            value.phone,
            isErrorPhoneNumber
          );
          setNetworkPhone(networkPhoneTmp);
          if (networkPhoneTmp === "") {
            isErr = true;
            setIsErrorPhoneNumber(true);
          }
        } else {
          setIsErrorPhoneNumber(false);
        }
      }

      if (
        value.fullName?.trim() !== "" &&
        value.phone !== "" &&
        value.phone.length === 10 &&
        value.isAgree &&
        value.isAgree1 &&
        !isErr
      ) {
        removeDisableBtn("#btn-register");
      } else {
        addDisableBtn("#btn-register");
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, isErrorPhoneNumber]);

  const hideModal = () => {
    setModal(false);
    setModalCard(false);
    setModalImage(false);
    setContent("");
    setNameBtn("");
    setNameBtn1("");
    setNameBtn2("");
    document.body.classList.remove("modal-open");
  };
  const startTimer = () => {
    if (timerId) clearTimeout(timerId);
    setTimerId(setTimeout(hideModal, 10000));
  };
  const stopTimer = () => clearTimeout(timerId);

  const removeModalOpen = () => {
    setIsLoading(false);
    document.body.classList.remove("modal-open");
  };
  useEffect(() => {
    if (otp.length === 6) {
      handleSubmitOTP();
    }
  }, [otp]);
  useEffect(() => {
    document.body.classList.add("bgr-blue");
    document.body.classList.remove("bgr-game");
    return stopTimer;
  }, []);
  const getCampaignInfo = () => {
    setIsLoading(true);
    dispatch(
      actions.GET_CAMPAIGN_INFO.request(
        {},
        (res) => {
          setIsLoading(false);
          removeDisableBtn("#btn-show-form");
          console.log("res>>>>>", res);
          if (!!res?.id) {
            localStorage.setItem("campaignInfo", JSON.stringify(res));
          }
        },
        (err) => {
          setIsLoading(false);
          addDisableBtn("#btn-show-form");
          checkError(err?.data?.ErrorCode);
        }
      )
    );
  };

  useEffect(() => {
    getCampaignInfo();
  }, []);

  const showModal = () => {
    setModal(true);
    document.body.classList.add("modal-open");
  };
  const closeModalOTP = () => {
    setModalOtp(false);
    setOtp("");
    setIsErrorOTP(false);
    document.body.classList.remove("modal-open");
    removeDisableBtn("#btn-register");
  };
  const clearField = (type) => {
    addDisableBtn("#btn-register");
    setValue("isAgree", false);
    setValue("isAgree1", false);
  };
  const onSubmit = (data) => {
    if (
      data.fullName !== "" &&
      data.phone !== "" &&
      data.isAgree &&
      data.isAgree1
    ) {
      handleJoin(data);
      setDataSubmit(data);
    }
  };

  const handleJoin = (data) => {
    handleCheckPhone(data);
    document.body.classList.add("modal-open");
    addDisableBtn("#btn-register");
  };

  const handleCheckPhone = (data) => {
    setIsLoading(true);
    dispatch(
      actions.CHECK_PHONE.request(
        { phoneNumber: data.phone },
        (res) => {
          setIsLoading(false);
          requestOTP(data);
          clearField();
        },
        (err) => {
          setIsLoading(false);
          clearField();
          checkError(err?.data?.ErrorCode);
        }
      )
    );
  };
  const addDisableBtn = (id) => {
    const el = document.querySelector(id);
    el.classList.add("disabled");
  };

  const removeDisableBtn = (id) => {
    const el = document.querySelector(id);
    el.classList.remove("disabled");
  };

  const handleSubmitOTP = () => {
    console.log("OTP===>", otp);
    setIsLoading(true);
    verifyOTP();
  };

  const resendOTP = () => {
    setIsErrorOTP(false);
    setOtp("");
    requestOTP(dataSubmit);
  };

  const verifyOTP = () => {
    let verifyOTPRequestTime = moment().utc().format();
    dispatch(
      actions.VERIFY_OTP.request(
        {
          phoneNumber: phoneNumber,
          otpCode: otp,
        },
        (res) => {
          setIsErrorOTP(false);
          requestLogin(verifyOTPRequestTime, res?.token?.accessToken);
        },
        (err) => {
          removeModalOpen();
          setIsErrorOTP(true);
        }
      )
    );
  };

  const requestLogin = (verifyOTPRequestTime, accessToken) => {
    signInWithCustomToken(getAuth(), accessToken)
      .then((authCredential) => {
        let user = authCredential?.user;
        console.log(user);
        localStorage.setItem("accessToken", user.accessToken || "");
        setIsLoading(false);
        dispatch(actions.REQUEST_LOGIN.request({ Otp: otp }));

        localStorage.setItem(
          "cardSenderInfo",
          JSON.stringify({
            otp: otp,
            name: dataSubmit.fullName,
          })
        );
        navigate("/card");
      })
      .catch((error) => {
        removeModalOpen();
        console.log(error);
      });
  };

  const handleOpenModalImage = (item) => {
    setModalImage(true);
    setContentCard(item);
  };

  const handleOpenModalCard = (item) => {
    // setModalCard(true);
    setModalImage(true);
    setContentCard({ ...item, urlImg: true });
  };
  const isValidPhone = (phone) => {
    var vnf_regex = /((09|03|07|08|05)+([0-9]{8})\b)/g;
    return vnf_regex.test(phone) ? true : false;
  };

  const checkError = (errCode) => {
    let content = "";

    switch (errCode) {
      case "MaxFailPerDay":
        content = `Quý khách đã gửi sai mã dự thưởng 5 lần liên <br/>tiếp và sẽ không được tiếp tục tham gia<br/> chương trình trong ngày hôm nay.<br/> Hãy trở lại sau nhé. ${HOTLINE}`;
        setNameBtn(`ĐÓNG`);
        break;

      case "MaxJoin":
        content = `Thuê bao đã đạt giới hạn số lần tham gia dự thưởng. Vui lòng quay trở lại sau.<br/>${HOTLINE}`;
        setNameBtn(`ĐÓNG`);
        break;

      case "CAMPAIGN_NOT_START_YET":
        content = `Chương trình chưa bắt đầu, vui lòng quay trở lại vào ngày <span>${START_DATE}</span>.`;
        setNameBtn(`ĐÓNG`);

        break;

      case "CAMPAIGN_ENDED":
        content = `Chương trình đã kết thúc, hẹn gặp lại bạn ở các chương trình sau!`;
        setNameBtn(`ĐÓNG`);

        break;
      case "INVALID_PHONE_NUMBER":
        content = `Chương trình đã kết thúc, hẹn gặp lại bạn ở các chương trình sau!`;
        setNameBtn(`ĐÓNG`);
        break;
      case "CARD_LIMIT":
        content = `Bạn đã tạo quá số lượng thiệp cho phép của chương trình. Hẹn gặp lại bạn ở chương trình khác`;
        setNameBtn(`ĐÓNG`);
        break;
      case "InvalidResendTime":
        content = `<p>Yêu cầu gửi mã OTP của bạn đang được chúng tôi xử lý, bạn hãy thử lại sau 1 phút nhé.<p/>`;
        setNameBtn(`ĐÓNG`);
        break;
      default:
        content = `Đã có lỗi xảy ra!<br/>
        Vui lòng kiểm tra lại`;
        setNameBtn(`ĐÓNG`);
        break;
    }
    setContent(`${content}`);
    showModal();
  };

  const showDefaultErrModal = () => {
    showModal();
    setNameBtn(`ĐÓNG`);
    setContent(`Đã có lỗi xảy ra!<br/>
    Vui lòng kiểm tra lại<br/>
    hoặc gọi đến ${HOTLINE}`);
  };

  const requestOTP = (data) => {
    setOtpRequestTime(moment().utc().format());
    localStorage.setItem("accessToken", "");
    dispatch(
      actions.REQUEST_SMS_OTP.request(
        {
          phoneNumber: data.phone,
        },
        (res) => {
          setOtpResponseTime(moment().utc().format());
          setPhoneNumber(data.phone);
          setFullName(data.fullName);
          setModalOtp(true);
          removeModalOpen();
        },
        (err) => {
          removeModalOpen();
          removeDisableBtn("#btn-register");
          checkError(err.data.error.message);
        }
      )
    );
  };

  const clickAction = () => {
    hideModal();
  };

  return (
    <div
      onClick={() => {
        if (modalOtp) {
          hideModal();
        }
      }}
    >
      <LoadingSpinner isLoading={isLoading} />
      <HomePageView
        register={register}
        setValue={setValue}
        getValues={getValues}
        handleSubmit={handleSubmit(onSubmit)}
        provinces={provinces}
        isErrorPhoneNumber={isErrorPhoneNumber}
        handleOpenModalImage={handleOpenModalImage}
        handleOpenModalCard={handleOpenModalCard}
        setContentCard={setContentCard}
      />

      {modalOtp && (
        <PopupOtp
          setModal={setModalOtp}
          setOtp={setOtp}
          otp={otp}
          handleSubmitOTP={handleSubmitOTP}
          closeModalOTP={closeModalOTP}
          resendOTP={resendOTP}
          isErrorOTP={isErrorOTP}
        />
      )}
      {isShowModalNoGift && (
        <PopupNoGift
          dataModalTopup={dataModalTopup}
          closeModal={setIsShowModalNoGift}
        />
      )}

      {modal && (
        <PopupMessage
          nameBtn={nameBtn}
          nameBtn1={nameBtn1}
          nameBtn2={nameBtn2}
          setModal={setModal}
          content={content}
          clickAction={clickAction}
          clickAction1={clickAction}
          clickAction2={clickAction}
        />
      )}

      {/* <PopupMessage isShow={false} content="Chương trình đã kết thúc. Hẹn gặp bạn trong các chương trình lần sau.<br/> <span>Hotline 1900 633 415</span>" nameBtn="Đóng" /> */}

      {/* {modalInput && <PopupInputCode setModalInput={setModalInput} content={content} />} */}
      {modalCard && (
        <PopupCard contentCard={contentCard} closeModalCard={clickAction} />
      )}
      {modalImage && (
        <PopupImage contentCard={contentCard} closeModalImage={clickAction} />
      )}
    </div>
  );
};

export default HomePage;
